import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { testimonials } from "@/mocks/testimonials";

const toneStyles: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-100 text-secondary-800",
};

export default function Testimonials() {
  return (
    <section className="w-full bg-background-100 px-4 py-16 md:px-6 md:py-24">
      <div className="mx-auto w-full">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="投稿者口碑"
            title="他们第一次投稿，就被编辑找上了"
            desc="有经验固然好，但更多被采用的线索，来自愿意把身边事讲清楚的普通人。"
          />
          <div className="flex items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-600">
            <i className="ri-star-fill text-base leading-none text-accent-500"></i>
            投稿者满意度 4.9 / 5.0
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.map((item, index) => (
            <Reveal key={item.name} delay={index * 80}>
              <figure className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-center gap-1 text-accent-500">
                  {[0, 1, 2, 3, 4].map((star) => (
                    <i key={star} className="ri-star-fill text-sm leading-none"></i>
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.content}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-full font-heading text-sm font-bold ${toneStyles[item.tone]}`}
                  >
                    {item.initial}
                  </span>
                  <span className="flex flex-col">
                    <span className="text-sm font-semibold text-foreground-900">{item.name}</span>
                    <span className="text-xs text-foreground-500">{item.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}